function getCurrentSubdomain() {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');

    if (parts.length > 2)
        return parts.slice(0, -2).join('.');

    return ''; // No subdomain
}

module.exports = {
    getCurrentSubdomain,
};



// WEBPACK FOOTER //
// src/commons/domain.js